export const convertValueName = (map: any, data: string): string => map[data]
